import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { FormattedText } from "@faire/retailer-visitor-shared/components/FormattedText";
import { AccordionContainer } from "@faire/retailer-visitor-shared/views/product/ProductDescriptionAccordions/AccordionContainer";
import { LazyEcoFriendlyInfoAccordionDetailsModal } from "@faire/retailer-visitor-shared/views/product/ProductDescriptionAccordions/LazyEcoFriendlyInfoAccordionDetailsModal";
import { StyledIconByName } from "@faire/retailer-visitor-shared/views/product/utils/StyledIconByName";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Suspense } from "@faire/web--source/ui/Suspense";
import { trackProductInfoEcoFriendlyInformationLearnMoreCtaClick } from "@faire/web-api--source/events/productInfo/click/ecoFriendlyInformationLearnMoreCta";
import { trackProductInfoPdpEcoFriendlyInfoShowDetailsClick } from "@faire/web-api--source/events/productInfo/click/pdpEcoFriendlyInfoShowDetails";
import { trackProductInfoEcoFriendlyInformationAccordionViewView } from "@faire/web-api--source/events/productInfo/view/ecoFriendlyInformationAccordionView";
import { observer } from "mobx-react";
import React, { useState } from "react";
import styled from "styled-components";
var ProductEcoFriendlyInfoAccordionBase = function(param) {
    var ecoFriendlyInfoSection = param.ecoFriendlyInfoSection;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(false), 2), openDetailsModal = _useState[0], setOpenDetailsModal = _useState[1];
    var initialNumberOfLinesShown = 3;
    var title = strictLocalize({
        id: "cjqVbR",
        defaultMessage: [
            {
                type: 0,
                value: "Eco-friendly information"
            }
        ]
    });
    var ecoFriendlyInfoText = ecoFriendlyInfoSection === null || ecoFriendlyInfoSection === void 0 ? void 0 : ecoFriendlyInfoSection.entries.flatMap(function(section) {
        var _section_text, _section_text1;
        var _section_text_translated;
        return (_section_text_translated = (_section_text = section.text) === null || _section_text === void 0 ? void 0 : _section_text.translated) !== null && _section_text_translated !== void 0 ? _section_text_translated : (_section_text1 = section.text) === null || _section_text1 === void 0 ? void 0 : _section_text1.original;
    }).filter(isNotUndefined);
    var ecoFriendlyAttributeFirstRowAttribute = ecoFriendlyInfoSection === null || ecoFriendlyInfoSection === void 0 ? void 0 : ecoFriendlyInfoSection.entries[0];
    var ecoFriendlyAttributeFirstRowEntry = ecoFriendlyInfoText === null || ecoFriendlyInfoText === void 0 ? void 0 : ecoFriendlyInfoText[0];
    if (!ecoFriendlyAttributeFirstRowAttribute || !ecoFriendlyAttributeFirstRowEntry) {
        return null;
    }
    var learnMoreCTA = function() {
        var _ecoFriendlyInfoSection_external_link, _ecoFriendlyInfoSection_external_link1, _ecoFriendlyInfoSection_external_link2, _ecoFriendlyInfoSection_external_link3;
        if (!((ecoFriendlyInfoSection === null || ecoFriendlyInfoSection === void 0 ? void 0 : (_ecoFriendlyInfoSection_external_link = ecoFriendlyInfoSection.external_link) === null || _ecoFriendlyInfoSection_external_link === void 0 ? void 0 : _ecoFriendlyInfoSection_external_link.text) && (ecoFriendlyInfoSection === null || ecoFriendlyInfoSection === void 0 ? void 0 : (_ecoFriendlyInfoSection_external_link1 = ecoFriendlyInfoSection.external_link) === null || _ecoFriendlyInfoSection_external_link1 === void 0 ? void 0 : _ecoFriendlyInfoSection_external_link1.url))) {
            return undefined;
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    width: 12
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    linkTo: (_ecoFriendlyInfoSection_external_link2 = ecoFriendlyInfoSection.external_link) === null || _ecoFriendlyInfoSection_external_link2 === void 0 ? void 0 : _ecoFriendlyInfoSection_external_link2.url,
                    target: "_blank",
                    style: {
                        minWidth: "76px",
                        whiteSpace: "nowrap"
                    },
                    onClick: function() {
                        return trackProductInfoEcoFriendlyInformationLearnMoreCtaClick();
                    },
                    children: /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.enabled,
                        children: (_ecoFriendlyInfoSection_external_link3 = ecoFriendlyInfoSection.external_link) === null || _ecoFriendlyInfoSection_external_link3 === void 0 ? void 0 : _ecoFriendlyInfoSection_external_link3.text
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AccordionContainer, {
                title: title,
                maxNumberOfLinesShownWhenCollapsed: initialNumberOfLinesShown,
                isCustomizedCollapsableComponent: true,
                collapsedComponent: collapsedInfoRow(ecoFriendlyAttributeFirstRowAttribute, ecoFriendlyAttributeFirstRowEntry),
                expandedComponent: ProductEcoFriendlyInfo(ecoFriendlyInfoSection, setOpenDetailsModal),
                onView: trackProductInfoEcoFriendlyInformationAccordionViewView
            }),
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyEcoFriendlyInfoAccordionDetailsModal, {
                    ecoFriendlyInfoSection: ecoFriendlyInfoSection,
                    onClose: function() {
                        return setOpenDetailsModal(false);
                    },
                    isOpen: openDetailsModal,
                    learnMoreCTA: learnMoreCTA()
                })
            })
        ]
    });
};
var collapsedInfoRow = function(ecoFriendlyAttributeFirstRowInfo, ecoFriendlyInfoSectionEntry) {
    var _ecoFriendlyAttributeFirstRowInfo_slate_icon;
    return /*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(IconWrapper, {
                children: /*#__PURE__*/ _jsx(StyledIconByName, {
                    name: (_ecoFriendlyAttributeFirstRowInfo_slate_icon = ecoFriendlyAttributeFirstRowInfo.slate_icon) === null || _ecoFriendlyAttributeFirstRowInfo_slate_icon === void 0 ? void 0 : _ecoFriendlyAttributeFirstRowInfo_slate_icon.type,
                    fontSize: "16px",
                    color: Core.icon.default,
                    strokeWidth: 1
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(FormattedText, {
                    text: ecoFriendlyInfoSectionEntry + "..."
                })
            })
        ]
    });
};
var ProductEcoFriendlyInfo = function(ecoFriendlyInfoSection, openDetailsModalHandler) {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            ecoFriendlyInfoSection === null || ecoFriendlyInfoSection === void 0 ? void 0 : ecoFriendlyInfoSection.entries.map(function(ecoFriendlyAttributeDetail) {
                return EcoFriendlyAttributeInfoRow(ecoFriendlyAttributeDetail);
            }),
            EcoFriendlyDetailsModalCTA(openDetailsModalHandler)
        ]
    });
};
var EcoFriendlyAttributeInfoRow = function(ecoFriendlyAttributeDetail) {
    var _ecoFriendlyAttributeDetail_text, _ecoFriendlyAttributeDetail_text1, _ecoFriendlyAttributeDetail_slate_icon, _ecoFriendlyAttributeDetail_slate_icon1;
    var _ecoFriendlyAttributeDetail_text_translated;
    var attributeEntry = (_ecoFriendlyAttributeDetail_text_translated = (_ecoFriendlyAttributeDetail_text = ecoFriendlyAttributeDetail.text) === null || _ecoFriendlyAttributeDetail_text === void 0 ? void 0 : _ecoFriendlyAttributeDetail_text.translated) !== null && _ecoFriendlyAttributeDetail_text_translated !== void 0 ? _ecoFriendlyAttributeDetail_text_translated : (_ecoFriendlyAttributeDetail_text1 = ecoFriendlyAttributeDetail.text) === null || _ecoFriendlyAttributeDetail_text1 === void 0 ? void 0 : _ecoFriendlyAttributeDetail_text1.original;
    return /*#__PURE__*/ _jsxs(ExpandedInfoRowWrapper, {
        children: [
            /*#__PURE__*/ _jsx(IconWrapper, {
                children: /*#__PURE__*/ _jsx(StyledIconByName, {
                    name: (_ecoFriendlyAttributeDetail_slate_icon = ecoFriendlyAttributeDetail.slate_icon) === null || _ecoFriendlyAttributeDetail_slate_icon === void 0 ? void 0 : _ecoFriendlyAttributeDetail_slate_icon.type,
                    fontSize: "16px",
                    color: Core.icon.default,
                    strokeWidth: 1
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(FormattedText, {
                    text: attributeEntry
                })
            })
        ]
    }, "eco-friendly-attribute-".concat((_ecoFriendlyAttributeDetail_slate_icon1 = ecoFriendlyAttributeDetail.slate_icon) === null || _ecoFriendlyAttributeDetail_slate_icon1 === void 0 ? void 0 : _ecoFriendlyAttributeDetail_slate_icon1.type));
};
var EcoFriendlyDetailsModalCTA = function(openDetailsModalHandler) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        onClick: function(event) {
            openDetailsModalHandler(true);
            trackProductInfoPdpEcoFriendlyInfoShowDetailsClick();
            // Stop propagate click event to accordion container
            event.stopPropagation();
            event.preventDefault();
        },
        children: /*#__PURE__*/ _jsx(Typography, {
            color: Core.text.enabled,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "HpyzzG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Show details"
                    }
                ]
            })
        })
    });
};
export var ProductEcoFriendlyInfoAccordion = observer(ProductEcoFriendlyInfoAccordionBase);
var ExpandedInfoRowWrapper = styled(Row).withConfig({
    componentId: "sc-69c1c0a3-0"
})([
    "margin-bottom:",
    ";",
    "{margin-bottom:12px;}"
], getSpacing("1x"), responsiveMediaQueries.mobile);
var IconWrapper = styled(Column).withConfig({
    componentId: "sc-69c1c0a3-1"
})([
    "margin:2px 12px 0 0;"
]);
